/**
 * P-19 CategoryTabHub — 外側タブSwiper + 内側パネルSwiper（thumbs連動）
 * @see docs/tds-components.md #11 P-19 CategoryTabHub
 */
(function () {
  var PANEL_SWIPE_OPTIONS = {
    preventClicks: true,
    preventClicksPropagation: true,
    threshold: 14,
    touchAngle: 40,
  };

  function destroySwiper(el) {
    if (el && el.swiper && typeof el.swiper.destroy === 'function') {
      el.swiper.destroy(true, true);
    }
  }

  function destroyHub(hub) {
    if (!hub) return;
    var tabsEl = hub.querySelector('[data-tds-hub-tabs]');
    var panelsEl = hub.querySelector('[data-tds-hub-panels]');
    destroySwiper(tabsEl);
    destroySwiper(panelsEl);
    // liquid側の静的ハードコードも含め、初期化前は必ず外す（FOUC制御）
    hub.removeAttribute('data-tds-hub-ready');
  }

  function syncActiveTab(tabsEl, index) {
    if (!tabsEl) return;
    var buttons = tabsEl.querySelectorAll('.tds-tabs__btn');
    buttons.forEach(function (btn, i) {
      btn.setAttribute('aria-selected', i === index ? 'true' : 'false');
    });
  }

  function bindTabClicks(tabsEl, panels) {
    if (!tabsEl || !panels) return;
    var buttons = tabsEl.querySelectorAll('.tds-tabs__btn');
    buttons.forEach(function (btn, index) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        panels.slideTo(index);
      });
    });
  }

  function initHub(hub) {
    if (!hub || typeof Swiper === 'undefined') return false;

    var tabsEl = hub.querySelector('[data-tds-hub-tabs]');
    var panelsEl = hub.querySelector('[data-tds-hub-panels]');
    if (!tabsEl || !panelsEl) return false;

    if (panelsEl.swiper && hub.getAttribute('data-tds-hub-ready') === 'true') {
      return true;
    }

    // 二重init防止: 既存インスタンスを壊してから作り直す
    destroyHub(hub);

    try {
      var tabs = new Swiper(tabsEl, {
        slidesPerView: 'auto',
        spaceBetween: 0,
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        threshold: 8,
        touchAngle: 45,
      });

      var panels = new Swiper(panelsEl, Object.assign({}, PANEL_SWIPE_OPTIONS, {
        autoHeight: true,
        spaceBetween: 0,
        slidesPerView: 1,
        loop: false,
        watchOverflow: true,
        speed: 300,
        thumbs: {
          swiper: tabs,
        },
        on: {
          init: function () {
            this.update();
            if (typeof this.updateAutoHeight === 'function') {
              this.updateAutoHeight(0);
            }
          },
          slideChange: function () {
            tabs.slideTo(this.activeIndex);
            syncActiveTab(tabsEl, this.activeIndex);
          },
        },
      }));

      bindTabClicks(tabsEl, panels);
      syncActiveTab(tabsEl, panels.activeIndex || 0);

      // 初期化直後の測定が不安定な場合の保険: レイアウト確定後に再計測
      window.requestAnimationFrame(function () {
        panels.update();
        if (typeof panels.updateAutoHeight === 'function') {
          panels.updateAutoHeight(0);
        }
      });
      window.addEventListener('load', function () {
        panels.update();
        if (typeof panels.updateAutoHeight === 'function') {
          panels.updateAutoHeight(0);
        }
      });

      // 初期化完了 → ここで初めて data-tds-hub-ready を付け直す
      hub.setAttribute('data-tds-hub-ready', 'true');
      return true;
    } catch (err) {
      console.error('[tds-category-hub] init failed', err);
      return false;
    }
  }

  function bootAll() {
    if (typeof Swiper === 'undefined') return false;
    document.querySelectorAll('[data-tds-hub]').forEach(initHub);
    return true;
  }

  function start() {
    if (bootAll()) return;
    // Swiper本体（swiper.min.js）の読み込み待ち。100msごとにリトライ
    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;
      if (bootAll() || tries >= 100) {
        window.clearInterval(timer);
      }
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var hub =
      (event.target.matches && event.target.matches('[data-tds-hub]') ? event.target : null) ||
      event.target.querySelector('[data-tds-hub]');
    if (hub) {
      initHub(hub);
      return;
    }
    start();
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var hub = event.target.querySelector('[data-tds-hub]');
    if (hub) destroyHub(hub);
  });
})();
